import './IconButton.scss';
import cn from 'classnames';
import { ComponentProps } from 'react';
import { Size } from '@Components/designConstants';
import { Button } from '../Button';
import { useToolbarSize } from '../Toolbar';

type IconButtonProps = Omit<
  ComponentProps<typeof Button>,
  | 'leadingElement'
  | 'trailingElement'
  | 'leadingElementIsInteractive'
  | 'trailingElementIsInteractive'
>;

export const IconButton = ({
  children,
  className = '',
  size: sizeProp,
  ...passthroughProps
}: IconButtonProps) => {
  const size = useToolbarSize(sizeProp, Size.LG);
  return (
    <Button size={size} {...passthroughProps} className={cn('bpm-icon-btn', className)}>
      {children}
    </Button>
  );
};
